module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("goVlo"))).then(() => parcelRequire('1iHdE'));